import { LangSwitchButton, LangSwitch } from '../comp/chooseLang/ChooseLang';
import type { PageContent } from '../comp/chooseLang/ChooseLang';
import './Global.css'

function Contact() {
    const pageContentPl: PageContent[] = [
        {
            header: 'Kontakt', type: 'full-title', content: '', custom: null
        },
        {
            header: '', type: 'sub', content: 'Napisz do mnie w sprawie projektów, współpracy lub pytań. Odpowiadam zwykle w ciągu kilku dni.', custom: null
        },
        {
            header: 'E-mail', type: 'sub', content: 'contact.mateuszgola@gmail.com', custom: null
        },
        {
            header: 'GitHub', type: 'sub', content: 'github.com/1mB33', custom: null
        },
        {
            header: 'LinkedIn', type: 'sub', content: 'linkedin.com/in/mateusz-gola-3b2702297/', custom: null
        },
        {
            header: '', type: 'spacer', content: '', custom: null
        },
    ];
    const pageContentEn: PageContent[] = [
        {
            header: 'Contact', type: 'full-title', content: '', custom: null
        },
        {
            header: '', type: 'sub', content: 'Write to me about projects, collaboration or questions. I usually reply within a few days.', custom: null
        },
        {
            header: 'E-mail', type: 'sub', content: 'contact.mateuszgola@gmail.com', custom: null
        },
        {
            header: 'GitHub', type: 'sub', content: 'github.com/1mB33', custom: null
        },
        {
            header: 'LinkedIn', type: 'sub', content: 'linkedin.com/in/mateusz-gola-3b2702297/', custom: null
        },
        {
            header: '', type: 'spacer', content: '', custom: null
        },
    ];

    var m = new Map<string, PageContent[]>();
    m.set('en', pageContentEn);
    m.set('pl', pageContentPl);


    return (
        <>
            <LangSwitch LangMap={m} />
        </>
    );
};

export default Contact;
